import * as Collapsible from '@radix-ui/react-collapsible';
import { PropsWithChildren, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export interface ICollapsibleBlockProps extends PropsWithChildren {
  title: string;
  expandedDefault?: boolean;
}

export const CollapsibleBlock = ({
  children,
  title,
  expandedDefault,
}: ICollapsibleBlockProps) => {
  const [open, setOpen] = useState(expandedDefault ?? false);

  return (
    <Collapsible.Root
      open={open}
      onOpenChange={setOpen}
      className="max-w-full w-full"
    >
      <Collapsible.Trigger>
        <div className="text-[#282828] text-[20px] flex flex-row items-center gap-[8px] font-[500]">
          {title}
          {open ? (
            <FaChevronDown
              style={{
                width: 12,
              }}
            />
          ) : (
            <FaChevronUp
              style={{
                width: 12,
              }}
            />
          )}
        </div>
      </Collapsible.Trigger>

      <Collapsible.Content>
        <div className="text-[14px] mt-[10px] text-black font-[300] w-full">
          {children}
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};
